module.exports = __webpack_public_path__ + "img/howto_sp04.1f508569.png";